module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-500-18a127e9dc689f1d2082e9072c8db23e.woff";